export default "__VITE_ASSET__BbFnsCsd__"